import React from 'react';
import { Result, Button } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../config/routes';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="抱歉，您访问的页面不存在"
      extra={
        <Button
          type="primary"
          icon={<HomeOutlined />}
          onClick={() => navigate(ROUTES.DASHBOARD)}
        >
          返回首页
        </Button>
      }
    />
  );
};
